/* eslint-disable react/destructuring-assignment */
import React from 'react';
import { SortUtilities } from '@pwc/pwc-deals-web-common';
import { Checkbox } from '@pwc/pwc-deals-ui';
import DateCell from '../../../../common/components/DateCell';
import LibraryItemDeleteButton from '../../../contentLibrary/LibraryItemDeleteButton/LibraryItemDeleteButton';
import getLibraryItemTypeDisplayName from './getLibraryItemTypeDisplayName';

function getColumnConfig(
  setAllItems,
  setSortColumnName,
  setSortColumnDirection,
  setSelectedLibraryItemIds,
  onDeleteLibraryItem
) {
  return [
    {
      Header: 'Name',
      accessor: 'name',
      className: 'bold-cell title-cell cell',
      sortType: SortUtilities.caseInsensitiveAlphaSort,
      Cell: (props) => {
        const {
          row,
          state: { sortBy },
        } = props;
        const { original: libraryItem } = row;
        const checkboxId = `library-item-checkbox-${libraryItem.id}`;
        return (
          <div>
            <Checkbox
              // className="library-item-checkbox"
              id={checkboxId}
              selected={libraryItem.selected}
              dataTestId="library-item-select-label"
              onChange={() => {
                setSelectedLibraryItemIds((oldSelectedLibraryItemsIds) => {
                  const newSelectedLibraryItemIdSet = new Set(
                    oldSelectedLibraryItemsIds
                  );
                  if (newSelectedLibraryItemIdSet.has(libraryItem.id)) {
                    newSelectedLibraryItemIdSet.delete(libraryItem.id);
                  } else {
                    newSelectedLibraryItemIdSet.add(libraryItem.id);
                  }
                  const newSelectedLibraryItemArray = Array.from(
                    newSelectedLibraryItemIdSet
                  );
                  return newSelectedLibraryItemArray;
                });

                const currentSort = sortBy[0];
                setSortColumnName(currentSort.id);
                setSortColumnDirection(currentSort.desc ? 'desc' : 'asc');
              }}
              label={libraryItem.name}
            />
          </div>
        );
      },
    },
    {
      Header: 'Date ingested',
      accessor: 'dateCreated',
      Cell: ({ cell }) => {
        return (
          <span data-testid="item-date-created">
            {cell.value ? <DateCell cell={cell} /> : ''}
          </span>
        );
      },
    },
    {
      Header: 'Type',
      id: 'type',
      accessor: (row) => getLibraryItemTypeDisplayName(row.type),
    },
    {
      Header: '',
      id: 'delete',
      disableSortBy: true,
      className: 'right-align-cell cell',
      Cell: (cell) => {
        const { original: libraryItem } = cell.row;
        return (
          <LibraryItemDeleteButton
            projectId={libraryItem.projectId}
            libraryItemId={libraryItem.id}
            onDelete={onDeleteLibraryItem}
            disabled={libraryItem.selected}
          />
        );
      },
    },
  ];
}

export default getColumnConfig;
